import { CheckCircle2, MessageCircle, PackageSearch } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useProduct } from "../api/hooks";
import { ProductShot } from "../components/ProductShot";
import { orderPlaced as text } from "../content/site";
import { formatOrderNumber } from "../lib/money";
import { useSupport } from "../lib/support";

/** Экран 10 ТЗ — «Заказ получен ✓»: номер, что дальше, отследить или задать вопрос. */
export function OrderPlacedScreen() {
  const { orderNumber = "" } = useParams();
  const navigate = useNavigate();
  const product = useProduct();
  const support = useSupport();

  return (
    <div className="screen screen--plain onb">
      <div className="onb__body onb__center">
        <div className="success">
          <CheckCircle2 size={48} strokeWidth={1.6} aria-hidden />
        </div>
        <h1 className="onb__title">{text.title}</h1>
        <p className="onb__subtitle">{text.body}</p>

        <div className="order-number">
          <span>{text.numberLabel}</span>
          <strong>{formatOrderNumber(orderNumber)}</strong>
        </div>

        <ProductShot product={product.data} size="small" />
      </div>

      <div className="onb__footer">
        <button type="button" className="button" onClick={() => navigate(`/orders/${encodeURIComponent(orderNumber)}`, { replace: true })}>
          <PackageSearch size={17} strokeWidth={1.9} aria-hidden /> {text.track}
        </button>
        <button type="button" className="button button--ghost" onClick={support.open} disabled={!support.available}>
          <MessageCircle size={17} strokeWidth={1.9} aria-hidden /> {text.ask}
        </button>
      </div>
    </div>
  );
}
